import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-results-resetting',
  templateUrl: './warning-results-resetting.component.html',
  styleUrls: ['./warning-results-resetting.component.scss'],
  standalone: false,
})
export class WarningResultsResettingComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
